<template>
  <div class="export-failed">
    <h3 class="export-failed__title">{{ t("failed_title") }}</h3>
    <p class="export-failed__hint">{{ t("failed_hint") }}</p>
  </div>
</template>

<script setup>
import { t } from "#ce/apps/SpDirectoryPdfExport/i18n";
</script>

<style lang="scss" scoped>
.export-failed {
  display: grid;
  gap: var(--sp-ref-scale-16);
  justify-items: start;
  color: var(--sp-sys-color-on-surface);
  // Text alignment inherited from the host's surroundings must not restyle the
  // drawer content.
  text-align: start;

  &__title {
    margin: 0;
    font: var(--sp-sys-typescale-h4-short);
  }

  &__hint {
    margin: 0;
    color: var(--sp-sys-color-on-surface-variant);
  }
}
</style>
